import { defineComponent } from '@nuxtjs/composition-api';

export default defineComponent({
  methods: {
    isAutofocused(fieldName: string): boolean {
      return fieldName === this.$route.query.field_key;
    },
  },
});
